export default __webpack_public_path__ + "static/media/cedula-vieja.a0531aa7.svg";